import React, { Component } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import IconButton from '@material-ui/core/IconButton'
import InstagramIcon from '@material-ui/icons/Instagram'
import FacebookIcon from '@material-ui/icons/Facebook'
import LinkedinIcon from '@material-ui/icons/LinkedIn'
import TelegramIcon from '@material-ui/icons/Telegram'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'

import Card from './Card.js';

import './App.css';

class App extends Component {
    constructor(props){
        super(props);
        this.state = {
            'activeTour': null
        };
    }

    handleTourClick = (e) => {
        const tourID = e.currentTarget.id;
        if(tourID === this.state.activeTour)
            this.setState({'activeTour': null});
        else
            this.setState({'activeTour': tourID});
    }

    render() {
        /*const gmap_coords = {
            lat: 44.842902,
            lng: 11.616540
        };*/
        return (
            <div className="App">
                {/*
                    <navbar />
                */}
                <Container className="cards-container">
                    <Card parallax big
                        imgPath="/images/Travel to Italy Ferrara.jpg"
                        content={
                        <div className="card-content">
                            <img src="/images/logo_white.png"
                                alt="KA-PA TOUR"
                                className="logo-image"/>
                            <br/>
                            <h2>
                                FISCHER AWARD 2018 - Best Incoming Tour Operator
                            </h2>
                            <Container className="card-elements-container">
                                <Row className="card-elements-row">
                                    <Col sm={6} className="card-element">
                                        <h2 className="element-header">
                                            Cultural Tours
                                        </h2><br />
                                        <span className="element-icon" >
                                            <img src="/images/icons8-museum-50.png" alt="cultural tours"/>
                                        </span>
                                        <p className="element-text">
                                            Discover the art and culture of Italy with our
                                            cultural tours, with visits to museums, art galleries
                                            and local monuments.
                                        </p>
                                    </Col>
                                    <Col sm={6} className="card-element">
                                        <h2 className="element-header">
                                            Incentive Groups
                                        </h2><br />
                                        <span className="element-icon" >
                                            <img src="/images/icons8-prize-50.png" alt="incentive groups"/>
                                        </span>
                                        <p className="element-text">
                                            Give your employees the best experiences with
                                            our incentive group tour packages
                                        </p>
                                    </Col>
                                </Row>
                                <Row className="card-elements-row">
                                    <Col sm={6} className="card-element">
                                        <h2 className="element-header">
                                            Pilgrimages
                                        </h2><br />
                                        <span className="element-icon" >
                                            <img src="/images/icons8-chapel-50.png" alt="pilgrimages"/>
                                        </span>
                                        <p className="element-text">
                                            We organize pilgrimages to various religious
                                            destinations across Italy
                                        </p>
                                    </Col>
                                    <Col sm={6} className="card-element">
                                        <h2 className="element-header">
                                            Congress Participants
                                        </h2><br />
                                        <span className="element-icon" >
                                            <img src="/images/icons8-user-groups-50.png" alt="congresses"/>
                                        </span>
                                        <p className="element-text">
                                            Full services for congress participants
                                        </p>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    } />
                    <Card content={
                        <div className="card-content">
                            <h1>What we offer</h1>
                            <Container className="card-elements-container">
                                <Row className="card-elements-row">
                                    <Col className="card-element">
                                        <h2 className="element-header">
                                            Accomodation
                                        </h2>
                                        <span className="element-icon" />
                                        <p className="element-text">
                                            We offer accommodation not only in hotels
                                            but also in country farms, apartments or hostels,
                                            to best suit your needs.
                                        </p>
                                    </Col>
                                    <Col className="card-element">
                                        <h2 className="element-header">
                                            Transport
                                        </h2>
                                        <span className="element-icon" />
                                        <p className="element-text">
                                            Transportation included by bus, car rental or
                                            with the Trenitalia high-speed rail network.
                                        </p>
                                    </Col>
                                </Row>
                                <Row className="card-elements-row">
                                    <Col className="card-element">
                                        <h2 className="element-header">
                                            Local food
                                        </h2>
                                        <span className="element-icon" />
                                        <p className="element-text">
                                            Eat in local restaurants and country farms to
                                            appreciate the typical Italian cuisine.
                                            Wine tasting, as well as samplings of olive oil
                                            and other products are too available.
                                        </p>
                                    </Col>
                                    <Col className="card-element">
                                        <h2 className="element-header">
                                            Additional services
                                        </h2>
                                        <span className="element-icon" />
                                        <p className="element-text">
                                            In addition to any other client requests, we
                                            provide local tour guides, as well priority tickets for
                                            local museums, art galleries, and other attractions.
                                        </p>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    } />
                    <Card parallax
                        imgPath="/images/Travel to Italy Ravello.jpg"
                        content={
                        <div className="card-content">
                            <h1>Working with us</h1>
                            <Container className="card-elements-container">
                                <Row className="card-elements-row">
                                    <Col sm={6} className="card-element">
                                        <h2 className="element-header">
                                            Tailor-made Tours
                                        </h2>
                                        <span className="element-icon" />
                                        <p className="element-text">
                                            Every our tour is tailor-made to our client's
                                            requests and needs, thanks to our excellent
                                            knowledge of the markets we operate in.
                                        </p>
                                    </Col>
                                    <Col sm={6} className="card-element">
                                        <h2 className="element-header">
                                            International experience
                                        </h2>
                                        <span className="element-icon" />
                                        <p className="element-text">
                                            We work with clients from a variety of foreign
                                            countries, and we speak fluently Italian, English and
                                            Czech. Communication is also possible in
                                            German, Spanish and Russian.
                                        </p>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    } />
                    <Card content={
                        <div className="card-content">
                        <h1>Example tours</h1>
                        <Container className="card-elements-container">
                            <Row className="card-elements-row">
                                <Col sm={4} className={"card-element tab-header"+(this.state.activeTour==="tour-tuscany"?" active":"")} id="tour-tuscany" onClick={this.handleTourClick}>
                                    <h2 className="element-header">
                                        Tuscany
                                    </h2>
                                    <i class="fas fa-chevron-down"></i>
                                </Col>
                                    <Col sm={4} className={"card-element tab-header"+(this.state.activeTour==="tour-tuscany-liguria"?" active":"")} id="tour-tuscany-liguria" onClick={this.handleTourClick}>
                                    <h2 className="element-header">
                                        Tuscany & Liguria
                                    </h2>
                                    <i class="fas fa-chevron-down"></i>
                                </Col>
                                <Col sm={4} className={"card-element tab-header"+(this.state.activeTour==="tour-emilia-romagna"?" active":"")} id="tour-emilia-romagna" onClick={this.handleTourClick}>
                                    <h2 className="element-header">
                                        Emilia Romagna
                                    </h2>
                                    <i class="fas fa-chevron-down"></i>
                                </Col>
                            </Row>
                            <Row className={"tab-text-row"+(this.state.activeTour==="tour-tuscany"?" active":"")} id="tour-tuscany-text">
                                <Col sm={4} className="tour-image d-none d-md-block">
                                    <img src="images/Visit Italy Tuscany.jpg" alt="Visit Italy Tuscany"/>
                                    <div className="tour-image-shadow" />
                                </Col>
                                <Col xs={12} md={8} className="tour-description">
                                    1st day:<br/>
                                    Arrival to Florence, pick-up in the airport – transfer to the centre and a HD visit with a local guide, transfer to the hotel in Chianti aerea.
                                    <br/>
                                    <br/>
                                    2nd day:<br/>
                                    After breakfast transfer to Siena with a short stop in Monteriggioni, HD visit of Siena, lunch,  in the afternoon San Gimignano and a wine and oil tasting in a farm near San Gimignano.Return to the hotel.
                                    <br/>
                                    <br/>
                                    3rd day:<br/>
                                    After breakfast transfer to Monte Oliveto Abbey, a visit and a good lunch in the area. After lunch a visit of Montalcino with a stop for the best coffee in the town in a  historical coffee bar in the centre, Brunello tasting with a possibility of a typical lunch, transfer to Montepulciano, a visit of the town with an eventual wine tasting in a historical wine cellar, return to the hotel.
                                    <br/>
                                    <br/>
                                    4th day:<br/>
                                    After breakfast transfer to Pienza, a HD visit. Lunch in a picturesque village Monticchiello near Pienza, a gourmet menu with a local Pecorino cheese, in the afternoon transfer to Montepulciano, a visit of the town with a wine tasting in a historical wine cellar, return to the hotel.
                                    <br/>
                                    <br/>
                                    5th day:<br/>
                                    After breakfast FD visit of Florence with a stop in an Etruscan town Fiesole, transfer to the airport.
                                </Col>
                            </Row>
                            <Row className={"tab-text-row"+(this.state.activeTour==="tour-tuscany-liguria"?" active":"")} id="tour-tuscany-liguria-text">
                                <Col md={4} className="tour-image d-none d-md-block">
                                    <img src="images/Visit Italy Liguria Tuscany.jpg" alt="Visit Italy Liguria Tuscany"/>
                                    <div className="tour-image-shadow" />
                                </Col>
                                <Col xs={12} md={8} className="tour-description">
                                1st day:<br/>
                                Arrival to Florence pick-up in the airport – transfer to the centre and a FD visit with a local guide, transfer to the hotel in Versilia area.
                                <br/>
                                <br/>
                                2nd day:<br/>
                                After breakfast transfer to Pisa, HD visit with free lunch, in the afternoon Pontedera with its Piaggio Museum (VESPA). An excellent Amedei chocolate tasting, return to the hotel.
                                <br/>
                                <br/>
                                3rd day:<br/>
                                After breakfast transfer to Puccini’s Lucca, a guided visit with a stop in  a  historical coffee bar in the centre, free lunch and in the afternoon transfer to Torre del Lago and a visit of Villa Puccini, return to the hotel.
                                <br/>
                                <br/>
                                4th day:<br/>
                                After breakfast transfer to Carrara and a visit of his famous Marble Museum, then transfer to Fantiscritti and an organized visit to the marble mines. After the visit a typical lunch in Colonnata with its typical Lardo di Colonnata, a short visit of the picturesque village. Return to the hotel.
                                <br/>
                                <br/>
                                5th day:<br/>
                                After breakfast FD visit by a motorboat or by a local train to the National Park of Cinque Terre with a possibility of wine tasting (Sciacchetrà). Return to the hotel.
                                <br/>
                                <br/>
                                6th day:<br/>
                                After breakfast FD visit the Portovenere and Lerici, return to the hotel.
                                <br/>
                                <br/>
                                7th day:<br/>
                                After breakfast transfer to the airport.
                                </Col>
                            </Row>
                            <Row className={"tab-text-row"+(this.state.activeTour==="tour-emilia-romagna"?" active":"")} id="tour-emilia-romagna-text">
                                <Col md={4} className="tour-image d-none d-md-block">
                                    <img src="images/Visit Bologna Ferrari Museum.jpg" alt="Visit Bologna Ferrari Museum"/>
                                    <div className="tour-image-shadow" />
                                </Col>
                                <Col xs={12} md={8} className="tour-description">
                                1st day:<br/>
                                Arrival to Bologna pick-up in the airport – transfer to the hotel and a FD/HD visit with a local guide (or a gourmet tour), an italian aperitive in the centre.
                                <br/>
                                <br/>
                                2nd day:<br/>
                                After breakfast transfer to Ferrara, HD visit with a stop for a good coffee, then a typical lunch in the centre. In the afternoon a Rizzati chocolate tasting, return to the hotel in Bologna.
                                <br/>
                                <br/>
                                3rd day:<br/>
                                After breakfast transfer to Maranello, a visit to the Ferrari Museum, lunch in a typical „Ferrari“ restaurant near the Museum. In the afternoon a HD visit of Modena and Aceto Balsamico tasting, return to the hotel in Bologna.
                                <br/>
                                <br/>
                                4th day:<br/>
                                After breakfast transfer to Parma, HD visit of the town. A typical lunch with Parma ham in a „agriturismo“ near the town and a visit of the castle of Torrechiara. Accomodation in a hotel in Reggio Emilia.
                                <br/>
                                <br/>
                                5th day:<br/>
                                After breakfast FD trip to Busseto (Verdi) and Cremona (Stradivari) with a good lunch in Busseto. Return to the hotel.
                                <br/>
                                <br/>
                                6th day:<br/>
                                After breakfast FD trip to Mantua and Sabbioneta, transfer to the airport.
                                </Col>
                            </Row>
                        </Container>
                        </div>
                    } />
                    <Card parallax
                        imgPath="/images/Travel to Italy Lake Garda.jpg"
                        content={
                        <div className="card-content">
                            <h1>Who we are</h1>
                            <Container className="card-elements-container">
                                <Row className="card-elements-row">
                                    <Col xs-hidden md={2} />
                                    <Col xs={12} md={8} className="card-element">
                                        <p className="element-text justified">
                                            KA-PA Tour is an Italian
                                            incoming tour operator. With more than 20 years of experience
                                            in organizing group tours, we have an expansive
                                            network of contacts with local hotels, restaurants and
                                            museums, as well as bus and car rental agencies.
                                            We are based in Ferrara, a pictoresque renaissance
                                            city in the Po valley, known for its magnificent
                                            city centre and local food.
                                            Even though our ties with the city are strong,
                                            our tours are organized in all the major Italian
                                            destinations.
                                        </p>
                                    </Col>
                                    <Col xs-hidden md={2} />
                                </Row>
                            </Container>
                        </div>
                    } />
                    <Card content={
                        <div className="card-content">
                            <h1>Outgoing</h1>
                            <Container className="card-elements-container">
                                <p className="element-text divider-down">Outgoing tours are available on request</p>
                                <Row className="card-elements-row">
                                    <Col className="card-element" md={6}>
                                        <h1>Contact Us!</h1><br/>
                                        <h4><b>Email:</b> <a href="mailto:kapatour@gmail.com">kapatour@gmail.com</a></h4>
                                        <h4><b>Cell.:</b> +39-349-8617280</h4>
                                        <h4><b>Tel./Fax:</b> +39-0532-242733</h4>
                                        <a
                                            href='https://wa.me/393498617280'
                                            target='_blank'
                                        >
                                            <IconButton>
                                                <WhatsAppIcon style={{ fontSize: 40 }} />
                                            </IconButton>
                                        </a>
                                        <a
                                            href=''
                                            target='_blank'
                                        >
                                            <IconButton>
                                                <TelegramIcon style={{ fontSize: 40 }} />
                                            </IconButton>
                                        </a>
                                        <a
                                            href='https://www.instagram.com/kapatour/'
                                            target='_blank'
                                        >
                                            <IconButton>
                                                <InstagramIcon style={{ fontSize: 40 }} />
                                            </IconButton>
                                        </a>
                                        <a
                                            href='https://www.facebook.com/KA-PA-tour-incoming-tour-operator-139111812826049/'
                                            target='_blank'
                                        >
                                            <IconButton>
                                                <FacebookIcon style={{ fontSize: 40 }} />
                                            </IconButton>
                                        </a>
                                        <p>
                                            Riassunto contributi statali ricevuti:
                                            <a href="contributi_pubblici.docx" download>docx</a>
                                        </p>
                                    </Col>
                                    <Col className="card-element" md={6}>
                                        <h1>Partner Sites</h1>
                                        <Row className="partner-container">
                                            <Col className="partner-col">
                                                <a className="partner-link" href="http://www.catiraglio.it/">
                                                    <img style={{height: "150px"}} className="partner-image" src="images/catiraglio_logo.png" alt="ca' tiraglio"/>
                                                </a>
                                            </Col>
                                            <Col className="partner-col">
                                                <a className="partner-link" href="https://www.cadelfondo.com/">
                                                    <img style={{height: "150px"}} className="partner-image" src="images/cadelfondo_logo.jpg" alt="ca' del fondo"/>
                                                </a>
                                            </Col>
                                            <Col className="partner-col">
                                                <a className="partner-link" href="http://www.casadebertoldi.it/en/">
                                                    <img style={{height: "150px"}} className="partner-image" src="images/Casa De Bertoldi.jpg" alt="Casa De Bertoldi"/>
                                                </a>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                    } />
                </Container>
            </div>
        );
    }
}

export default App;
